module.exports = __webpack_public_path__ + "static/media/AppleStore.548fe994.svg";